/**
 * 复制文本到剪贴板（T-9325）。
 *
 * 双通道，任一成功即返回 true：
 * 1. `navigator.clipboard`——安全上下文 + 用户手势下可用；
 * 2. 回落 `document.execCommand("copy")`——微信 webview 内 Clipboard API
 *    会被拒或直接缺失（旧实现只走通道 1，在微信里静默失败：用户点了没反应、
 *    也不知道该改用什么办法）；
 *    回落时先把 `fallbackNode` 的选区选中再复制，该节点同时是页面上可长按
 *    选中的网址文本——即使两条通道都失败，选中本身也是给用户的可视兜底。
 *
 * **返回值必须被消费**：false = 复制没成功，调用方要给出可见反馈
 * （改文案 / 提示长按），不得静默。
 */
export async function copyText(
  text: string,
  fallbackNode: HTMLElement | null
): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    // 微信 webview 内 Clipboard API 不可用 → 走 execCommand 兜底
  }

  if (!fallbackNode) return false

  try {
    const range = document.createRange()
    range.selectNodeContents(fallbackNode)
    const selection = window.getSelection()
    selection?.removeAllRanges()
    selection?.addRange(range)
    return document.execCommand("copy")
  } catch {
    return false
  }
}
